
import Styles from "./CalendarContainer.module.scss"
import classnames from "classnames"
import NotificationCard from "../notification-card/NotificationCard"
import { APP_KEY_IDS, DEVICE_TYPE } from "../../constants/constants"
import { RootStateOrAny, useSelector } from "react-redux"
import MainCalendar from "./main-calendar/MainCalendar"


const Calendar = () => {

  const notifications = useSelector((state: RootStateOrAny) => state.handleNotifications)
  
  return (
    <div className={classnames(Styles.container)}>

      <div className={Styles.notifications}>
        {
          notifications
            ?
            <>
              <ul className={Styles.notifications}>
                {
                  Object.keys(notifications).map((key: any, index: number) => {
                    return (
                      <li key={index} style={{ animationDelay: `${index / 4}s` }} className={classnames(index < notifications.length - 1 ? Styles.notification_block : "")} >
                        <NotificationCard id={key} deviceType={DEVICE_TYPE.DESKTOP} mobileAppId={notifications[key].mobileAppId} appId={notifications[key].appId} appName={notifications[key].appName} title={notifications[key].title} subText={notifications[key].subText} time={notifications[key].time} bannerImage={notifications[key].bannerImage || ""} visitLink={notifications[key].visitLink || ""} />
                      </li>
                    )
                  })
                }
              </ul>
            </>
            : null
        }
      </div>

      <div className={Styles.calendar_container}>
        <div className={Styles.schedule}>
          No Events today
        </div>
        <div className={Styles.calendar}>
          <MainCalendar/>
        </div>
      </div>
    </div>
  )
}

export default Calendar


